exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.groupbuy_tabs[data-v-4ecb2b39] {\n  padding: 12px;\n}\n", ""]);

// exports
